/* eslint-disable react/display-name */
/**
 * @file
 *
 * Defines the basic page auth contorl in this repo.
 */
import React from 'react';
import { Redirect } from 'react-router-dom';
import { isHaveAuth } from '~helpers/auth';
import generatePath from '~settings/routing';

/**
 * authControl
 *
 * Example:
 * @authControl({
 *   entity: String, // platform entity
 *   action: String, // Action to operate entity
 *   redirectFunc: (props) => { return 'redirectUrl' } // Redirect url
 * })
 * class YourComponent {}
 */

const validateAuthentication = (entity, action) =>
  (typeof entity === 'string' && isHaveAuth(entity, action)) ||
  (Array.isArray(entity) && entity?.some(en => isHaveAuth(en, action)));

const authControl =
  (entity, action, redirectFunc = () => {}, otherCondition = () => false) =>
  Component =>
  (
    props, // eslint-disable-next-line jsx-control-statements/jsx-use-if-tag
  ) => {
    return validateAuthentication(entity, action) || otherCondition() ? (
      <div>
        <Component {...props} />
      </div>
    ) : (
      <Redirect to={redirectFunc(props) || generatePath('properties')} />
    );
  };
export default authControl;
